
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row">
    <div class="col">
      <button class="btn btn-primary btn-block finalize-btn" type="button">Finalize Project</button>
    </div>
  </div>
</div>